import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
import ChatIcon from "./ChatIcon.js";
class AdvisorsBusy extends Component {
  render() {
    var _a;
    return /* @__PURE__ */ jsxs("div", { id: "queue-view", children: [
      /* @__PURE__ */ jsxs("div", { className: "header", children: [
        /* @__PURE__ */ jsx(ChatIcon, { className: "large" }),
        /* @__PURE__ */ jsx("span", { className: "dpd-customer-services", children: "DPD Customer Services" })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "message wide-message", children: [
        "All of our advisors are busy at the moment.",
        !((_a = this.props) == null ? void 0 : _a.hideEmailByAdvisorsBusy) && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("br", {}),
          /* @__PURE__ */ jsx("br", {}),
          "You can try again later or to send us an email please",
          " ",
          /* @__PURE__ */ jsx(
            "a",
            {
              href: `mailto:${!this.props.queue || this.props.queue === "Elite" ? "elite@dpd.co.uk" : "platinum@dpd.co.uk"}`,
              children: "click here"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { id: "leave-queue", style: { visibility: "hidden" }, children: [
        /* @__PURE__ */ jsx("button", { onClick: this.props.onLeave, children: "Close chat" }),
        /* @__PURE__ */ jsx("button", { className: "flat-white-reverse", onClick: this.props.onBack, children: "Return to chat" })
      ] })
    ] });
  }
}
AdvisorsBusy.propTypes = {
  hideEmailByAdvisorsBusy: PropTypes.bool,
  queue: PropTypes.string,
  onLeave: PropTypes.func,
  onBack: PropTypes.func
};
export {
  AdvisorsBusy as default
};
//# sourceMappingURL=AdvisorsBusy.js.map
